
/* ============================== src/components/FormField.jsx ============================== */
// src/components/FormField.jsx
// Подписанное поле формы: input / textarea / select / combobox.
import { useId } from "react";
import { Select } from "./Select";

export const FormField = ({
  label,
  type = "text",
  value,
  onChange,
  disabled,
  options,
  required,
  inline = false,
  error,
  multiple = false,
  below = null,
  after = null,
  placement,
  // footer - только для type="select"/"combobox": нода внизу попапа.
  // Для остальных типов игнорируется (не пробрасывается).
  // Вынесен из ...props: иначе React ругнулся бы на неизвестный
  // DOM-атрибут в <input>/<textarea>.
  footer = null,
  // editable - только для type="select": режим combobox (input вместо
  // button-триггера). См. Select.jsx.
  editable = false,
  placeholder,
  ...props
}) => {
  const id = `field-${useId()}`;
  const handleChange = (e) => onChange(e.target.value);

  const inputElement = (() => {
    if (type === "select") {
      return (
        <Select
          id={id}
          value={multiple ? (value ?? []) : (value ?? "")}
          onChange={onChange}
          options={options}
          disabled={disabled}
          multiple={multiple}
          placement={placement}
          footer={footer}
          editable={editable}
          placeholder={placeholder}
        />
      );
    }
    if (type === "textarea") {
      return (
        <textarea
          className="inp"
          id={id}
          rows={props.rows || 2}
          value={value ?? ""}
          onChange={handleChange}
          disabled={disabled}
        />
      );
    }
    return (
      <input
        className="inp"
        type={type}
        id={id}
        value={value ?? ""}
        onChange={handleChange}
        disabled={disabled}
        placeholder={placeholder}
        {...props}
      />
    );
  })();

  const inputWithAfter = after ? (
    <div className="field-with-after">
      <div className="field-with-after-input">{inputElement}</div>
      {after}
    </div>
  ) : (
    inputElement
  );

  const errorNode = error ? <div className="field-error">{error}</div> : null;

  if (inline) {
    return (
      <div className="field-row">
        <label className="field-label" htmlFor={id}>
          {label}
          {required && <span className="required-star">*</span>}
        </label>
        <div className="flex-1">
          {inputWithAfter}
          {errorNode}
          {below}
        </div>
      </div>
    );
  }

  return (
    <>
      <label className="lbl" htmlFor={id}>
        {label}
        {required && <span className="required-star">*</span>}
      </label>
      {inputWithAfter}
      {errorNode}
      {below}
    </>
  );
};
